/**
 * A wrapper function for Vue.filter() instances to ensure they still work but warn against there
 * use.
 * Filters should be imported and registered at a component level. e.g:
 * import { dashEmpty } from '@/Filters/text';
 * ...
 * filters: { dashEmpty },
 *
 * Using Vue.filter() makes it available app wide and it can get messy.
 */
export default (val, filter) => {
  console.warn(
    `The filter '${filter.name}' has been registered globally but
    should be registered at a component level`,
  );
  return filter(val);
};
